import React from "react";
import { FaInstagram, FaPhone } from "react-icons/fa";

const Footer = () => {
  return (
    <div className="footer">
      <h5>Affordable Services &copy; 2021</h5>
      <p>
        <FaPhone /> (+234) 803326773
      </p>
      <div className="social-icons">
        {/* <FaTwitter className="social-icons-tw" />
        <FaFacebook className="social-icons-fb" /> */}
        <a href="https/instagram.com/affordable-services">
          <FaInstagram className="social-icons-in" />
        </a>
      </div>
    </div>
  );
};

export default Footer;
